export function decodeIfNeeded(source) {
    return source ? decodeURIComponent(source) : source;
}
